import React from 'react'

/**
 * 
 * @param {*} props assetImage | className 
 * @returns 
 */
export default function AssetImage(props) {
  return (
    <img
      src={props.assetImage.src}
      alt={props.assetImage.alt}
      className={`${props.className}`}
      style={props.style}
    />
  )
}
